export enum DormerModalContentKey {
  NONE = 'none',
  HELP = 'help',
  COST_SUMMARY = 'cost-summary',
  REQUEST_QUOTATION = 'request-quotation',
  CONFIRMATION_PROMPT = 'confirmation_prompt',
}
